import React from "react";
import {
  Column,
  Card,
  CardImage,
  CardBody,
  CardTitle,
  CardTime,
  PaymentBackground,
  CardAction,
  CardActionIcons,
  CardRecipeYield,
  LefoverBanner,
  RecipeOwner,
} from "styles/MainCards.styled";
import { NoImage } from "styles/Preview.styled";
import { Shadow } from "./styled";
import { Icon } from "components/SvgIcons";
import { timeConvert } from "../../../helpers/getFormatedTime";
import cloudfront from "helpers/cloudfront";
import { getImageName } from "../../../helpers";
import { useRouter } from "next/router";

const RecipeCard = ({ item, isPrivateCollection, showModal, isNewLanding }) => {
  const router = useRouter();

  if (!item.recipe && (item.eat_outside || item.eat_leftovers)) {
    return (
      <Column key={new Date().getDate() + item.eat_outside ? "_outisde" : "_lefovers"} onClick={showModal}>
        <Card type={"recipe"} key={item.eat_outside ? "outisde" : "lefovers"}>
          <CardImage style={{ background: "linear-gradient(rgba(34, 36, 36, 0) 54.17%, rgba(34, 36, 36, 0.5) 100%)" }}>
            {item.eat_outside && <img className="cloudfront" src={"/images/eatingOutside.png"} alt={"eat outside"} />}
            {item.eat_leftovers && (
              <img className="cloudfront" src={"/images/eatingLeftovers.png"} alt={"eat leftovers"} />
            )}
            <Shadow></Shadow>
          </CardImage>
          <CardBody>
            <CardTitle>
              {item.eat_outside && "Eat outside"}
              {item.eat_leftovers && "Eat leftovers"}
            </CardTitle>
          </CardBody>
        </Card>
      </Column>
    );
  }

  return (
    <Column
      key={item.recipe.id}
      onClick={() => {
        if (isNewLanding) {
          router.push({ pathname: `/mobile/recipes/${item.recipe.id}` });
        } else {
          showModal();
        }
      }}
    >
      <Card type={"recipe"} key={item.recipe.id}>
        <CardImage>
          {item.recipe.main_image_url ? (
            <img
              className="cloudfront"
              src={cloudfront({ href: item.recipe.main_image_url, size: "medium" })}
              alt={getImageName(item.recipe.main_image_url)}
            />
          ) : (
            <NoImage />
          )}
          {!item.eat_leftovers && (
            <PaymentBackground>
              {item.recipe.purchased ? (
                <Icon icon="newpurchase" />
              ) : isPrivateCollection ? (
                <Icon icon="private" />
              ) : item.recipe.paid && item.recipe.price ? (
                `$${item.recipe.price}`
              ) : (
                "Free"
              )}
            </PaymentBackground>
          )}

          {item.eat_leftovers && (
            <LefoverBanner>
              <img src={`/icons/fork-knife.svg`} width={16} height={16} alt={"foodie-desktop"} />
              <span>Leftovers</span>
            </LefoverBanner>
          )}

          <CardAction>
            <CardActionIcons></CardActionIcons>
            <CardTime>{timeConvert(item.recipe.total_time)}</CardTime>
          </CardAction>
          <Shadow></Shadow>
        </CardImage>
        <CardBody>
          <CardTitle>{item.recipe.title}</CardTitle>
          {item.recipe_yield && item.recipe_yield_name && (
            <CardRecipeYield>
              {item.recipe_yield} {item.recipe_yield_name}
            </CardRecipeYield>
          )}

          {item.recipe && item.recipe.recipe_creator && (
            <RecipeOwner>
              <img src={cloudfront({ href: item.recipe.recipe_creator.image_url, size: "small" })} alt={"avatar"} />
              <span>{item.recipe.recipe_creator.name}</span>
            </RecipeOwner>
          )}
        </CardBody>
      </Card>
    </Column>
  );
};
export default RecipeCard;
